/* eslint-disable react-hooks/exhaustive-deps */
import { useContext,useEffect } from "react";
import Context from '../context/context'
import LeftPanel from "../components/LeftPanel";
import Header from "../components/Header";
import VoucherStockTransfer from "../components/inventory-account/VoucherStockTransfer";

export default function InventoryPage() {
  const context = useContext(Context);
  const {inventoryPageContent, setInventoryPageContent} = context;
  useEffect(()=>{
    if(window.location.pathname.includes("/Inv-Ac/Voucher-Stock-Transfer")){
      setInventoryPageContent(<VoucherStockTransfer/>)
    }
  },[])
  return (
    <>
      <LeftPanel />
      <div className="right-side">
        <Header />
        <div className='inventory'>
          {inventoryPageContent ?
            inventoryPageContent
          :
            <div className='underconstruction'></div>
          }
        </div>
      </div>
    </>
  );
}
